module.exports = __webpack_public_path__ + "img/icon-arrow-right.7b0bb5ab.svg";